import script from "./ProductAdditionalInfoSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAdditionalInfoSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductAdditionalInfoSkeleton.vue?vue&type=style&index=0&id=81bdcbe8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81bdcbe8"]])

export default __exports__